import React from "react";
import { Check } from "lucide-react";

export function Field({ label, value, onChange, testid, required, placeholder = "", type = "text", full = false }) {
  return (
    <div className={full ? "sm:col-span-2" : ""}>
      <label className="label">{label}{required && " *"}</label>
      <input type={type} required={required} className="input" value={value || ""} placeholder={placeholder}
             onChange={(e) => onChange(e.target.value)} data-testid={testid} />
    </div>
  );
}

export function TextArea({ label, value, onChange, testid, required, placeholder = "", rows = 3, full = true }) {
  return (
    <div className={full ? "sm:col-span-2" : ""}>
      <label className="label">{label}{required && " *"}</label>
      <textarea required={required} rows={rows} className="input resize-none" value={value || ""}
                placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
    </div>
  );
}

export function SelectField({ label, value, onChange, options, testid, required, placeholder = "Select…", full = false }) {
  return (
    <div className={full ? "sm:col-span-2" : ""}>
      <label className="label">{label}{required && " *"}</label>
      <select className="input" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
        <option value="">{placeholder}</option>
        {options.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    </div>
  );
}

export function ChipMulti({ label, options, values = [], onChange, max, testid }) {
  const toggle = (opt) => {
    const has = values.includes(opt);
    let next;
    if (has) next = values.filter((v) => v !== opt);
    else if (max && values.length >= max) return; // cap
    else next = [...values, opt];
    onChange(next);
  };
  return (
    <div className="sm:col-span-2">
      <div className="flex items-baseline justify-between mb-2">
        <label className="label !mb-0">{label}</label>
        {max && <div className="text-[10px] text-white/40 tracking-widest uppercase">Up to {max} • Selected {values.length}/{max}</div>}
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => {
          const active = values.includes(o);
          return (
            <button
              key={o}
              type="button"
              onClick={() => toggle(o)}
              data-testid={`${testid}-${o.replace(/\s|&/g, "_")}`}
              className={`px-3 py-1.5 text-xs uppercase tracking-wider border transition ${
                active ? "bg-gold text-black border-gold" : "border-gold/40 text-white/80 hover:border-gold hover:text-gold"
              }`}
            >
              {active && <Check size={12} className="inline mr-1" />}
              {o}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function RadioPills({ label, options, value, onChange, testid }) {
  return (
    <div className="sm:col-span-2">
      <label className="label">{label}</label>
      <div className="flex flex-wrap gap-2">
        {options.map((o) => {
          const active = value === o;
          return (
            <button
              key={o}
              type="button"
              onClick={() => onChange(o)}
              data-testid={`${testid}-${o.replace(/\s|&|\$|,/g, "_")}`}
              className={`px-3 py-1.5 text-xs uppercase tracking-wider border transition ${
                active ? "bg-gold text-black border-gold" : "border-gold/40 text-white/80 hover:border-gold hover:text-gold"
              }`}
            >
              {o}
            </button>
          );
        })}
      </div>
    </div>
  );
}
